var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 5,
    fill: "#252525"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2966 32.5935H31.5466V18.7187C31.5466 18.3304 31.2318 18.0156 30.8435 18.0156H28.031C27.6427 18.0156 27.3279 18.3304 27.3279 18.7187V32.5935H25.9216V23.4062C25.9216 23.0179 25.6068 22.7031 25.2185 22.7031H22.4061C22.0178 22.7031 21.703 23.0179 21.703 23.4062V32.5935H20.2967V25.9843C20.2967 25.596 19.9819 25.2812 19.5936 25.2812H16.7811C16.3928 25.2812 16.078 25.596 16.078 25.9843V32.5935H14.6718V27.6717C14.6718 27.2834 14.357 26.9686 13.9687 26.9686H11.1562C10.7679 26.9686 10.4531 27.2834 10.4531 27.6717V32.5935H9.70312C9.31481 32.5935 9 32.9084 9 33.2967C9 33.685 9.31481 33.9998 9.70312 33.9998H32.2966C32.6849 33.9998 32.9997 33.685 32.9997 33.2967C32.9997 32.9084 32.6849 32.5935 32.2966 32.5935Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70312 25.1079C14.0914 25.1079 18.8502 23.5319 23.1029 20.6702C26.4336 18.4289 29.21 15.5657 30.9346 12.6338L31.6174 15.1822C31.7016 15.4964 32.1081 15.7678 32.4786 15.6794C32.8563 15.5893 33.0762 15.1934 32.9757 14.8183L31.8243 10.5213C31.7238 10.1463 31.3384 9.9236 30.9632 10.0241L26.6662 11.1755C26.2912 11.276 26.0686 11.6616 26.1691 12.0366C26.2696 12.4117 26.655 12.6344 27.0302 12.5338L29.7984 11.7921C28.1894 14.5879 25.5303 17.3417 22.3178 19.5035C18.2947 22.2108 13.8147 23.7017 9.70312 23.7017C9.31481 23.7017 9 24.0165 9 24.4048C9 24.7931 9.31481 25.1079 9.70312 25.1079Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatIcon);
export default __webpack_public_path__ + "static/media/statIcon.eaf57fcf71af116f0e6e1c1f6ddb4b1c.svg";
export { ForwardRef as ReactComponent };